module.exports = __webpack_public_path__ + "resources/img/img_voice_studio1.3b7a6fdcf1fb7d56e5f7430d03fa9d56.png";